<header class="header">
  <div class="container-logo" (click)="view = !view">
    <h1 class="logo">
      <img
        src="assets/images/LogoIntro.png"
        alt="Analytiko"
        title="Analytiko"
      />
    </h1>
  </div>

  <!-- <div class="container-nav">
    <i class="fas fa-bars" (click)="view = !view" *ngIf="!view"></i>
    <i class="fas fa-chevron-left" (click)="view = !view" *ngIf="view"></i>
  </div> -->

  <div class="container-options">
    <div class="content-config">
      <div class="names mrleft">
        <h3 class="name cerom">{{ name }}</h3>
        <h3 class="role name cerom">{{ roeleName }}</h3>
      </div>

      <mat-icon
        [matBadge]="countNotifications"
        matBadgePosition="before"
        matBadgeColor="accent"
        matBadgeSize="small"
        class="notification-button mrleft"
        (click)="viewNotifications = !viewNotifications"
        >notifications</mat-icon
      >

      <div *ngIf="viewNotifications" class="notificaciones">
        <app-notificaciones
          [notificaciones]="notificaciones"
          [view]="viewNotifications"
          (hidden)="viewNotifications = false"
        ></app-notificaciones>
      </div>

      <!-- <div class="user_section" (click)="viewConfig = !viewConfig">
        <h3 class="role name">{{ roeleName }}</h3>
        <h3 class="name">{{ name }}</h3>
        <img [src]="photo" />
      </div> -->

      <div class="user_section mrleft pointer" [matMenuTriggerFor]="userMenu">
        <!-- <div>
          <h3 class="name">{{ name }}</h3>
          <h3 class="role name">{{ roeleName }}</h3>
        </div> -->
        <img *ngIf="photo" [src]="photo" />
        <mat-icon *ngIf="!photo" class="color-icon-circle"
          >account_circle</mat-icon
        >
      </div>
      <!-- <i class="fas fa-ellipsis-v" *ngIf="!viewConfig" (click)="viewConfig = !viewConfig"></i>
      <i class="fas fa-chevron-right" *ngIf="viewConfig" (click)="viewConfig = !viewConfig"></i> -->

      <!-- mat-menu: se cierra al hacer clic afuera, con Esc y al elegir una opción
           (antes era un toggle manual que se quedaba abierto). -->
      <mat-menu #userMenu="matMenu" xPosition="before" class="menu-user">
        <a mat-menu-item routerLink="/profile">
          <i class="fa fa-user"></i> Perfil
        </a>
        <button mat-menu-item (click)="doLogout()">
          <i class="fa fa-power-off"></i> Salir
        </button>
      </mat-menu>
    </div>
  </div>
</header>

<nav class="nav" [ngClass]="{ view: view }">
  <ul class="list-items" *ngIf="nav.length > 0">
    <ng-container *ngFor="let item of nav">
      <li
        *ngIf="item.if"
        class="item"
        [ngClass]="{ view: item.view && item.subNav }"
        (click)="(item.click)"
      >
        <a (click)="clickNav(item)">
          <!-- <i class="fas fa-{{ item.icon }}"></i> -->
          <img
            src="../../../../assets/images/icons/{{ item.icon }}.png"
            alt=""
            class="images-icon"
          />
          <span class="title-item">{{ item.name }}</span>
          <i class="fas fa-angle-down iconSubNav" *ngIf="item.subNav"></i>
        </a>
        <ul
          class="sub-items"
          *ngIf="item.subNav && item.if"
          [ngClass]="{ view: item.view }"
        >
          <ng-container *ngFor="let subItem of item.subNav">
            <li class="sub-item" *ngIf="subItem.if">
              <a
                (click)="clickNav(subItem)"
                [ngClass]="subItem.subNav ? 'subnav' : ''"
              >
                <span class="blackSpan">{{ subItem.name }}</span>
                <i class="fas fa-angle-down" *ngIf="subItem.subNav"></i>
              </a>
              <ul
                class="sub-items two"
                *ngIf="item.subNav && item.if"
                [ngClass]="{ view: subItem.view }"
              >
                <ng-container *ngFor="let subItemTwo of subItem.subNav">
                  <li class="sub-item" *ngIf="subItemTwo.if">
                    <a
                      (click)="clickNav(subItemTwo)"
                      [ngClass]="subItemTwo.subNav ? 'subnav' : ''"
                    >
                      <span>{{ subItemTwo.name }}</span>
                    </a>
                  </li>
                </ng-container>
              </ul>
            </li>
          </ng-container>
        </ul>
      </li>
    </ng-container>
  </ul>
</nav>
<div>
  <router-outlet></router-outlet>
</div>
